// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"styles_buttonsContainer__17Q0X","submitButton":"styles_submitButton__2ewXf","title":"styles_title__3aF8h"};